import { render } from "./AppBanner.vue?vue&type=template&id=30e98cd0"
import script from "./AppBanner.vue?vue&type=script&lang=js"
export * from "./AppBanner.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Dominik/Documents/GitHub/deptart/deptart/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__